import {getCurrentYear} from '../../utils/commons'
import TopPersonalProductReviewsLogo from './logo'
import {topPersonalProductReviewsCA, topPersonalProductReviewsUK} from './styles'

const baseConfig = {
  domainName: 'toppersonalproductreviews' as const,
  siteName: 'Top Personal Product Reviews',
  favicon: '/favicons/toppersonalproductreviews.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-02V2Q5L6N8',
    domainType: 'eu' as const,
    camelCaseUrl: 'TopPersonalProductReviews.co.uk',
    logo: <TopPersonalProductReviewsLogo className="size-9 shrink-0 tablet:size-7 mobile:size-6" locale="uk" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in the UK | TopPersonalProductReviews.co.uk – Expert Reviews`,
    description: (_category?: string, _count?: string) =>
      `At TopPersonalProductReviews.co.uk, we handpicked the best ranked personal products for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart shopping choices`,
    styles: topPersonalProductReviewsUK,
  },
  ca: {
    measurementId: 'G-M923QMQTW7',
    domainType: 'picks' as const,
    camelCaseUrl: 'TopPersonalProductReviews.ca',
    logo: <TopPersonalProductReviewsLogo className="size-9 shrink-0 tablet:size-7 mobile:size-6" locale="ca" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in CA | TopPersonalProductReviews.ca – Expert Reviews`,
    description: (_category?: string, _count?: string) =>
      `At TopPersonalProductReviews.ca, we handpicked the best ranked personal products for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart shopping choices.`,
    styles: topPersonalProductReviewsCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
